<template lang="pug">
.home(:class="$style.root")
  section#banner.section(:class="$style.banner")
    div(:class="$style.title")
      .title.is-1 桃園市
        br
        | 屏東同鄉會
      p.is-size-4(ref="subtitle")
  section#board.section
    .tile.is-ancestor
      .tile.is-vertical
        .tile
          .tile.is-parent.is-6
            article.tile.is-child.notification.is-white(:class="$style.about")
              the-home-about
          .tile.is-parent.is-6
            article.tile.is-child.notification.is-warning(:class="$style.articleWrap")
              the-home-news(:items="news")
        .tile
          .tile.is-parent.is-12
            article.tile.is-child.notification.is-white(:class="[$style.articleWrap, $style.activity]")
              the-home-activity(:article="activity")
        .tile
          .tile.is-parent
            article.tile.is-child.notification.is-light
              .title 理事長的一封信
              TheHomeChairmantalk
</template>

<script>
import Typewriter from "typewriter-effect/dist/core";
import TheHomeAbout from "@/components/TheHomeAbout.vue";
import TheHomeNews from "@/components/TheHomeNews.vue";
import TheHomeActivity from "@/components/TheHomeActivity.vue";
import TheHomeChairmantalk from "@/components/TheHomeChairmantalk.vue";

export default {
  name: "Home",
  components: {
    TheHomeAbout,
    TheHomeNews,
    TheHomeActivity,
    TheHomeChairmantalk
  },
  data() {
    return {
      news: [],
      activity: null,
      readmore: false
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    const typer = new Typewriter(this.$refs.subtitle, {
      loop: true,
      autoStart: true
    });

    typer
      .typeString("純樸")
      .pauseFor(500)
      .typeString("、憨厚")
      .pauseFor(500)
      .typeString("、熱情")
      .pauseFor(500)
      .typeString("、豪邁")
      .pauseFor(500)
      .typeString("<br/>阮係屏東郎。")
      .pauseFor(3000)
      .deleteAll()
      .start();
  },
  methods: {
    async fetchData() {
      const newsSnap = this.$f.db
        .collection("articles")
        .where("type", "==", "news")
        .where("published", "==", true)
        .orderBy("creationTime", "desc")
        .limit(5)
        .get()
        .then(snap => {
          this.news = this.$u.parseDbSnap(snap);
        });
      const activitySnap = this.$f.db
        .collection("articles")
        .where("type", "==", "activity")
        .where("published", "==", true)
        .orderBy("creationTime", "desc")
        .limit(1)
        .get()
        .then(snap => {
          this.activity = this.$u.parseDbSnap(snap)[0];
        });

      return Promise.all([newsSnap, activitySnap]);
    }
  }
};
</script>

<style module lang="sass">
.root :global(.tile)
  min-width: 0

.banner
  position: relative
  height: 100vh
  background-image: url("@/assets/images/banner.jpg")
  background-size: cover
  background-position: right
  top: -52.5px
  .title
    position: absolute
    top: 35%

.articleWrap
  width: 100%

.about
  border: 2px solid $info
  color: $grey-dark !important

.activity
  border: 2px solid $info
  color: $grey-dark !important
</style>
